import React from 'react';
import { Calendar, Phone, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-122">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 -z-10 w-1/2 h-full bg-blue-50 rounded-l-[100px] hidden lg:block" data-id="element-123" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-126">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-bold mb-6" data-id="element-127">
              <span className="relative flex h-2 w-2 mr-2" data-id="element-128">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-129"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600" data-id="element-130"></span>
              </span>
              Serving Charlotte & Surrounding Areas
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight mb-6" data-id="element-131">
              Reliable <span className="text-blue-600" data-id="element-132">Wheelchair</span>{' '}
              Transportation You Can Trust
            </h1>
            <p className="text-lg text-slate-600 mb-8 max-w-xl leading-relaxed" data-id="element-133">
              At AMO Wheelchair Transportation Services, we believe mobility
              should never be a barrier. Safe, reliable, and compassionate
              door-to-door service for medical appointments, social outings, and
              daily living.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-134">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-xl shadow-blue-200 flex items-center justify-center" data-id="element-135">
                <Calendar className="w-5 h-5 mr-2" data-id="element-136" />
                Book Your Ride
              </button>
              <a href="tel:7040000000" className="bg-white border-2 border-slate-200 text-slate-900 px-8 py-4 rounded-xl font-bold text-lg hover:border-blue-600 hover:text-blue-600 transition-all flex items-center justify-center" data-id="element-137">
                <Phone className="w-5 h-5 mr-2" data-id="element-138" />
                (704) AMO-RIDE
              </a>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-139">
              {['Fully Accessible', 'Trained Drivers', 'On-Time Priority', '24/7 Support'].map(item => <div key={item} className="flex items-center text-slate-700 font-medium" data-id="element-140">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-2" data-id="element-141" />
                  {item}
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-142">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl border-8 border-white bg-white" data-id="element-143">
              <img src="https://cdn.magicpatterns.com/uploads/9BkF54dhW9rhG3G5objMj2/Sample.jpg" alt="AMO Wheelchair Accessible Van" className="w-full h-[500px] object-contain p-4" data-id="element-144" />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/5 to-transparent" data-id="element-145" />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl z-20 max-w-xs hidden sm:block" data-id="element-146">
              <div className="flex items-center mb-3" data-id="element-147">
                <div className="bg-blue-100 p-2 rounded-lg mr-3" data-id="element-148">
                  <Phone className="w-6 h-6 text-blue-600" data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <p className="text-xs text-slate-500 font-bold uppercase tracking-wider" data-id="element-151">
                    Need a ride now?
                  </p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-152">
                    Call (704) AMO-RIDE
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-600" data-id="element-153">
                Our dispatchers are ready to assist you with immediate
                scheduling.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}